import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';

/**
 * Extends NativeDateAdapter to correctly parse European date strings (dd.MM.yyyy).
 *
 * The default NativeDateAdapter delegates to Date.parse(), which in V8 (Chrome)
 * interprets dot-separated date strings in US order (MM.DD.YYYY). This means a
 * user typing "05.03.2026" (5 March) would be stored as May 3rd instead.
 *
 * This adapter intercepts the dd.MM.yyyy pattern and constructs the Date directly
 * from the constituent parts, then falls back to the native behaviour for all
 * other formats (ISO 8601 strings, numeric timestamps, picker selections, etc.).
 */
@Injectable()
export class EuropeanDateAdapter extends NativeDateAdapter {
  override parse(value: unknown): Date | null {
    if (typeof value === 'string') {
      const match = value.match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})$/);
      if (match) {
        const day = parseInt(match[1], 10);
        const month = parseInt(match[2], 10) - 1; // Date months are 0-indexed
        const year = parseInt(match[3], 10);
        const d = new Date(year, month, day);
        // Guard against day overflow (e.g. "31.04.2026" would roll over to May)
        if (
          d.getFullYear() === year &&
          d.getMonth() === month &&
          d.getDate() === day
        ) {
          return d;
        }
        return this.invalid();
      }
    }
    return super.parse(value);
  }
}
